import { render } from "./Rate.vue?vue&type=template&id=2ea9b5e6"
import script from "./Rate.vue?vue&type=script&lang=js"
export * from "./Rate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__